<template>
  <div
    class="card shadow table-container vld-parent"
    ref="fundos_table"
    :class="type === 'dark' ? 'bg-default' : ''"
  >
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <router-link :to="{ name: 'admin_fundos_new' }">
            <base-button type="primary" size="sm" :custom="true"
              >Criar novo fundo</base-button
            >
          </router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="tableData"
      >
        <template slot="columns">
          <th>Tag</th>
          <th>Data ínicio</th>
          <th>Data fim</th>
          <th>Valor do fundo</th>
          <th>Batches</th>
          <th title="Investidores previstos x registrados">Investidores</th>
          <th>Status do fundo</th>
          <th>Ações</th>
        </template>

        <template slot-scope="{ row }">
          <th scope="row" class="pb-4 pt-4">
            <div class="media align-items-center">
              <i :class="getClass(row.type)" class="ni ni-tag mr-3"> </i>
              <div class="media-body">
                <span class="name mb-0 text-sm">
                  <router-link
                    :to="`/admin/fundos/${row.id}/editar`"
                    class="btn btn-link pl-0"
                  >
                    {{ row.tag }}
                  </router-link>
                </span>
              </div>
            </div>
          </th>
          <td>
            {{ row.start_date }}
          </td>
          <td>
            {{ row.end_date }}
          </td>
          <td class="budget">
            {{ row.value }}
          </td>
          <td>
            <div
              class="bg-white border rounded px-1 py-2 text-dark text-center"
            >
              <span title="cadastrados no fundo"
                ><b>{{ row.number_current_batches || 0 }}</b>
              </span>
              de
              <span title="previstos"
                >{{ row.batches }}
                <i class="fas fa-award text-dark-green fa-sm ml-1"></i
              ></span>
            </div>
          </td>
          <td>
            <div
              class="bg-white border rounded px-1 py-2 text-dark text-center"
            >
              <span title="registrados no fundo"
                ><b>{{ row.number_current_investors || 0 }}</b>
              </span>
              de
              <span title="previstos"
                >{{ row.number_investors }}
                <i class="fas fa-user-tie fa-sm ml-1"></i
              ></span>
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <span class="completion mr-2">{{ row.completion }}%</span>
              <div>
                <base-progress
                  :type="row.statusInfo.type"
                  :show-percentage="false"
                  :striped="true"
                  class="pt-0"
                  :value="row.completion"
                />
              </div>
              <span class="ml-2" :title="row.statusInfo.description">{{
                row.statusInfo.name
              }}</span>
            </div>
          </td>
          <td>
            <router-link
              :to="'/admin/fundos/' + row.id + '/editar'"
              class="btn btn-white py-1 px-2"
              title="Editar fundo"
              ><i class="fas fa-edit text-info"></i
            ></router-link>
            <router-link
              :to="'/admin/fundos/' + row.id + '/investidores'"
              class="btn btn-white py-1 px-2"
              title="Gerenciar investidores"
              ><i class="fas fa-user-tie text-dark"></i
            ></router-link>
            <router-link
              :to="'/admin/fundos/' + row.id + '/batches'"
              class="btn btn-white py-1 px-2"
              title="Gerenciar batches"
              ><i class="fas fa-award text-dark-green"></i
            ></router-link>
            <router-link
              :to="'/admin/fundos/' + row.id + '/metricas'"
              class="btn btn-white py-1 px-2"
              title="Gerenciar métricas do fundo"
              ><i class="fas fa-chart-line text-primary"></i
            ></router-link>
            <router-link
              :to="'/admin/fundos/' + row.id + '/financeiro'"
              class="btn btn-white py-1 px-2"
              title="Gerenciar relatório financeiro"
              ><i class="fas fa-coins text-dark-yellow"></i
            ></router-link>
          </td>
        </template>
      </base-table>
      <p v-if="empty" class="text-center text-warning mt-3">
        Nenhum fundo cadastrado até o momento
      </p>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  name: "fundos-table",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      tableData: [],
      empty: false,
      aceleracaoClass: "text-red",
      preAceleracaoClass: "text-blue",
      mistoClass: "text-yellow",
      fundStatus: [
        {
          key: "open",
          value: "Regular",
          description:
            "Um fundo regular fica visível para os investidores cadastrados no fundo.",
        },
        {
          key: "closed",
          value: "Encerrado",
          description:
            "O status 'Encerrado' ficará visível para os investidores cadastrados no fundo.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Um fundo invisível fica oculto para todos os investidores.",
        },
      ],
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.fundos_table,
      width: 90,
      height: 90,
    });
    try {
      const { data } = await api.get("/funds");
      data.forEach((fund) => {
        fund["completion"] = this.getCompletion(fund.start_date, fund.end_date);
        fund["start_date"] = this.formatDate(fund.start_date);
        fund["end_date"] = this.formatDate(fund.end_date);
        fund["value"] = this.formatValue(fund.value);
        fund["statusInfo"] = this.getStatusInfo(fund.status, fund.completion);
      });
      if (data.length) {
        this.tableData = data;
        this.$emit("calculatedStats", this.getStats());
      } else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os fundos");
    }
  },
  methods: {
    getCompletion(start, end) {
      const d1 = this.moment(start);
      const d2 = this.moment(end);
      const today = this.moment();
      if (today.isSameOrAfter(d2, "day")) return 100;
      if (today.isSameOrBefore(d1, "day")) return 0;
      let totalDays = d2.diff(d1, "days");
      let remainingDays = d2.diff(today, "days");
      if (totalDays > 0 && remainingDays > 0)
        return Math.round(Math.abs((1 - remainingDays / totalDays) * 100));
      return 0;
    },
    getStatusInfo(currentStatus, completion) {
      const selectedStatus = this.fundStatus.find(
        (status) => status.key === currentStatus
      );

      let statusInfo = {
        type: "info",
        name: selectedStatus.value,
        description: selectedStatus.description,
      };
      if (completion === 100) statusInfo.type = "success";
      else if (selectedStatus.key === "closed") statusInfo.type = "warning";
      if (selectedStatus.key === "hidden") statusInfo.type = "danger";
      return statusInfo;
    },
    getClass(type) {
      if (type === "Aceleração") return this.aceleracaoClass;
      else if (type == "Pré-aceleração") return this.preAceleracaoClass;
      return this.mistoClass;
    },
    getStats() {
      const stats = {
        totalFunds: 0,
        regularFunds: 0,
        fundTypes: {},
        expectedBatchesAvg: 0,
        expectedInvestorsAvg: 0,
        currentBatchesAvg: 0,
        currentInvestorsAvg: 0,
      };
      this.tableData.forEach((fund) => {
        stats.totalFunds++;
        if (fund.status === "open") stats.regularFunds++;
        if (stats.fundTypes[fund.type]) stats.fundTypes[fund.type]++;
        else stats.fundTypes[fund.type] = 1;
        stats.expectedBatchesAvg += fund.batches;
        stats.expectedInvestorsAvg += fund.number_investors;
        stats.currentBatchesAvg += fund.number_current_batches;
        stats.currentInvestorsAvg += fund.number_current_investors;
      });
      if (stats.totalFunds > 0) {
        stats.expectedBatchesAvg = Math.round(
          stats.expectedBatchesAvg / stats.totalFunds
        );
        stats.expectedInvestorsAvg = Math.round(
          stats.expectedInvestorsAvg / stats.totalFunds
        );
        stats.currentBatchesAvg = Math.round(
          stats.currentBatchesAvg / stats.totalFunds
        );
        stats.currentInvestorsAvg = Math.round(
          stats.currentInvestorsAvg / stats.totalFunds
        );
      }
      return stats;
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
</style>
